import{Item as t}from"@react-stately/collections";const o=t;o.toString=()=>".nextui-dropdown-item-base";export default o;